import * as actionTypes from './ActionTypes';
import {postRequest, getRequest,putRequest,postRequestFile,postRequestVerify,loginRequest,postResetPass} from '../Helper/ApiHit'

// export const getInterviewerTimeSlots = (date,id) => {
//     return (dispatch) => {
//         dispatch({type:actionTypes.GET_INTERVIEWER_TIME_SLOTS_INITIAL});
//             postRequest('employer/getInterviewerTimeSlots',{
//                     "date": date,
//                     "interviewerId": id
//             })
//             .then(res=>{
//                 if(res.data.responseStatus.statusCode === 0){
//                     return dispatch({
//                         type:actionTypes.GET_INTERVIEWER_TIME_SLOTS_SUCCESS,
//                         myScheduleTimingResponseList:res.data.responseData.myScheduleTimingResponseList,
//                         interviewerAvailableSlotResponseList:res.data.responseData.interviewerAvailableSlotResponseList
//                     })
//                 }
//                else{
//                 return dispatch({
//                     type:actionTypes.GET_INTERVIEWER_TIME_SLOTS_FAIL,
//                     payload: res.data.responseData.message
//                 })
//                }
//             })
//             .catch(err=>{
//                 return dispatch({
//                     type: actionTypes.GET_INTERVIEWER_TIME_SLOTS_NETWORK_ERROR,
//                     payload: err.message
//                 })
//             })
//     }
// }

export const getInterviewerListByDateAndTime = (page, data) => {
    return dispatch => {
        dispatch({type:actionTypes.GET_INTERVIEWER_PROFILE_INITIAL});
        postRequest(`employer/getInterviewerListByDateAndTime?page=${page}&limit=6`,data)
        .then(res => {
        
            if(res.data.responseStatus.statusCode ===0 ){
               
             return dispatch({
                 type:actionTypes.GET_INTERVIEWER_PROFILE_SUCCESS,
                 payload:res.data.responseData.interviewerList,
                 records:res.data.responseData.commonPaginationResponse.totalNumberOfPagesAsPerGivenPageLimit
             })    
         }
         else{
             
             return dispatch({
                 type:actionTypes.GET_INTERVIEWER_PROFILE_FAIL,
                 payload:"No Data Found"
             })
         }
         })
         .catch(err=>{
             console.log(err)
             return dispatch({
                 type:actionTypes.GET_INTERVIEWER_PROFILE_FAIL,
                 payload :"Server Error"
             })
         })
 }
 }


 export const getInterviewerTimeSlots = (date,id) => {
    return (dispatch) => {
        dispatch({type:actionTypes.GET_INTERVIEWER_TIME_SLOTS_INITIAL});
            postRequest('employer/getInterviewerTimeSlots',{
                    "date": date,
                    "interviewerId": id
            })
            .then(res=>{
                if(res.data.responseStatus.statusCode === 0){
                    return dispatch({
                        type:actionTypes.GET_INTERVIEWER_TIME_SLOTS_SUCCESS,
                        myScheduleTimingResponseList:res.data.responseData.myScheduleTimingResponseList,
                        interviewerAvailableSlotResponseList:res.data.responseData.interviewerAvailableSlotResponseList
                    })
                }
               else{
                return dispatch({
                    type:actionTypes.GET_INTERVIEWER_TIME_SLOTS_FAIL,
                    payload: res.data.responseData.message
                })
               }
            })
            .catch(err=>{
                return dispatch({
                    type: actionTypes.GET_INTERVIEWER_TIME_SLOTS_NETWORK_ERROR,
                    payload: err.message
                })
            })
    }
}

export const saveFilters=(date,type)=>{
    return dispatch => {
        dispatch({
            type: actionTypes.SAVE_FILTER_VALUE,
            payload:date,
            typeDate:type
        })
    }
}


export const saveFilterTimeSlot=(data)=>{
    return dispatch => {
        dispatch({
            type: actionTypes.SAVE_FILTER_VALUE_BY_TIME_SLOT,
            payloadTime:data,
           
        })
    }
}


export const saveFilterByName=(data)=>{
    return dispatch => {
        dispatch({
            type: actionTypes.SAVE_FILTER_VALUE_BY_NAME,
            payload:data,
           
        })
    }
}

export const clearAllFilter=()=>{
    return dispatch => {
        dispatch({
            type: actionTypes.CLEAR_ALL_SAVED_FILTER_AT_INTERVIEWER,
                 
        })
    }
}